import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net";
import Searchbox from "./search_box";
import Filter from "./filter";
import { filterObjectList } from "./util";
import * as LocalConfig from "./local_config";
import Loadingicon from "./loading_icon";
import Alertdialog from "./dialogbox";
import { getColumns } from "./columns";
import { Markup } from "interweave";

const DatasetList = ({ listId }) => {
  const tableRef = useRef(null);
  const [state, setState] = useState({
    isLoaded: false,
    objlist: [],
    statobj: {},
    filterlist: [],
    searchquery: "",
    dialog: { status: false, msg: "" }
  });

  useEffect(() => {
    const fetchData = async () => {
      const reqObj = { list_id: listId };
      const svcUrl = LocalConfig.apiHash.dataset_list;
      try {
        const res = await fetch(svcUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(reqObj)
        });
        const result = await res.json();
        if (result.status === 0) {
          setState((prev) => ({
            ...prev,
            dialog: { status: true, msg: result.error },
            isLoaded: true
          }));
        } else {
          setState((prev) => ({
            ...prev,
            objlist: result.recordlist,
            statobj: result.stats,
            searchquery: result.searchquery,
            isLoaded: true
          }));
        }
      } catch (error) {
        setState((prev) => ({ ...prev, isLoaded: true, error }));
      }
    };
    fetchData();
  }, [listId]);

  useEffect(() => {
    if (!state.isLoaded || state.objlist.length === 0) return;

    const tableCols = getColumns("tableone");
    const passedObjList = filterObjectList(state.objlist, state.filterlist).passedobjlist;

    const tableRows = passedObjList.map((obj) => {
      const row = {};
      tableCols.forEach((col) => {
        const field = col.field === "id" ? "bcoid" : col.field;
        row[col.field] = obj[field];
      });
      row.details = {
        bcoid: row.id,
        label: "... view details",
        rowlist: obj.rowlist || []
      };
      return row;
    });

    const formatDetails = (d) => {
      if (!d.details?.rowlist?.length) {
        return `<div style="padding:10px;">No extra details available.</div>`;
      }
      const rowsHtml = d.details.rowlist
        .map(
          (r) => `
        <tr>
          <td>${r.name || ""}</td>
          <td>${r.value || ""}</td>
          <td>${r.notes || ""}</td>
        </tr>`
        )
        .join("");
      return `
        <table class="child-table" cellpadding="5" cellspacing="0" border="0" style="margin-left:50px;">
          <thead>
            <tr><th>Name</th><th>Value</th><th>Notes</th></tr>
          </thead>
          <tbody>${rowsHtml}</tbody>
        </table>
      `;
    };

    const table = $(tableRef.current).DataTable({
      data: tableRows,
      columns: [
        { className: "dt-control", orderable: false, data: null, defaultContent: "" },
        ...tableCols.map((col) => ({
          title: col.label || col.field,
          data: col.field
        }))
      ],
      order: [[1, "asc"]]
    });

    $(tableRef.current).on("click", "tbody td.dt-control", function () {
      const tr = $(this).closest("tr");
      const row = table.row(tr);

      if (row.child.isShown()) {
        row.child.hide();
        tr.removeClass("shown");
      } else {
        row.child(formatDetails(row.data())).show();
        tr.addClass("shown");
      }
    });

    return () => {
      table.destroy(true);
    };
  }, [state.isLoaded, state.objlist, state.filterlist]);

  if (!state.isLoaded) return <Loadingicon />;
  if (state.dialog.status)
    return <Alertdialog dialog={state.dialog} onClose={() => setState((s) => ({ ...s, dialog: { status: false, msg: "" } }))} />;

  const resultSummary =
    "total" in state.statobj
      ? `<b>${state.statobj.total}</b> datasets found.`
      : "";

  return (
    <div>
      <div className="searchboxwrapper">
        <div style={{ textAlign: "center" }}>
          Search results for `{state.searchquery}`,<br />
          <a href="/">Click Here</a> to Reset Search
        </div>
      </div>

      <div className="statscn">
        <Markup content={resultSummary} />
      </div>

      <div className="searchresultscn">
        <table ref={tableRef} className="display" style={{ width: "100%" }}></table>
      </div>
    </div>
  );
};

export default DatasetList;

